import requset from "utils/request";
import baseURL from "./env";
/**签到列表**/
export function signlist(params) {
  return requset({
    url: `${baseURL.apiURL}/user/periodic/sign/list`,
    method: "GET",
    params,
  });
}
/**周期性签到**/
export function signperiodic(params) {
  return requset({
    url: `${baseURL.apiURL}/user/periodic/sign`,
    method: "GET",
    params,
  });
}
/**周期性补签到**/
export function signperiodicretroactive(params) {
  return requset({
    url: `${baseURL.apiURL}/user/periodic/sign/retroactive`,
    method: "GET",
    params,
  });
}
/**福利列表**/
export function rewardlist(params) {
  return requset({
    url: `${baseURL.apiURL}/interact/reward/list`,
    method: "GET",
    params,
  });
}
/**领取福利**/
export function rewardget(params) {
  return requset({
    url: `${baseURL.apiURL}/interact/reward/get`,
    method: "GET",
    params,
  });
}
